import type { AIAgentOrbPalette } from 'src/components/AIAgentOrb';
import type { AIManagerAvatarPaletteId, AIManagerGoal } from 'src/services/AIManagersService';

export const AI_MANAGER_AVATAR_PALETTES: Record<AIManagerAvatarPaletteId, AIAgentOrbPalette> = {
    aurora: {
        accent: '#6F7DFF',
        core: 'radial-gradient(circle at 25% 28%, rgba(255,255,255,0.95) 0 10%, rgba(255,255,255,0.42) 28%, transparent 44%), linear-gradient(135deg, #DEE6FF 0%, #7A83FF 46%, #9BC2FF 100%)',
        wash: 'radial-gradient(circle at 34% 28%, rgba(255,255,255,0.9), transparent 28%), radial-gradient(circle at 72% 66%, rgba(111,125,255,0.42), transparent 36%)',
        glow: 'rgba(79, 97, 255, 0.16)',
    },
    telegram: {
        accent: '#2AABEE',
        core: 'radial-gradient(circle at 24% 26%, rgba(255,255,255,0.92) 0 9%, rgba(255,255,255,0.38) 26%, transparent 42%), linear-gradient(135deg, #E7F7FF 0%, #5EA8FF 45%, #74E3D8 100%)',
        wash: 'radial-gradient(circle at 36% 26%, rgba(255,255,255,0.88), transparent 28%), radial-gradient(circle at 70% 70%, rgba(42,171,238,0.42), transparent 36%)',
        glow: 'rgba(42, 171, 238, 0.16)',
    },
    violet: {
        accent: '#8F7CFF',
        core: 'radial-gradient(circle at 27% 31%, rgba(255,255,255,0.94) 0 10%, rgba(255,255,255,0.4) 28%, transparent 44%), linear-gradient(135deg, #F0ECFF 0%, #8F7CFF 47%, #B7D0FF 100%)',
        wash: 'radial-gradient(circle at 35% 26%, rgba(255,255,255,0.9), transparent 30%), radial-gradient(circle at 74% 65%, rgba(143,124,255,0.42), transparent 36%)',
        glow: 'rgba(143, 124, 255, 0.16)',
    },
    mint: {
        accent: '#2FC6A3',
        core: 'radial-gradient(circle at 26% 29%, rgba(255,255,255,0.94) 0 10%, rgba(255,255,255,0.4) 27%, transparent 43%), linear-gradient(135deg, #EAFBF5 0%, #4AC5B5 45%, #86A7FF 100%)',
        wash: 'radial-gradient(circle at 36% 26%, rgba(255,255,255,0.9), transparent 29%), radial-gradient(circle at 72% 68%, rgba(47,198,163,0.42), transparent 36%)',
        glow: 'rgba(47, 198, 163, 0.16)',
    },
};

export const AI_MANAGER_GOAL_HINTS: Record<AIManagerGoal, string> = {
    qualify:
        'AI-менеджер общается с потенциальным клиентом и выясняет детали: подробнее про задачу, сроки, бюджет и контакт для связи',
    recommend_service:
        'AI-менеджер нативно рекомендует Telegram-канал, внешний сервис, продукт или услугу под запрос потенциального клиента',
};

export const AI_MANAGER_GOAL_DEFAULT_DATA: Record<AIManagerGoal, string[]> = {
    qualify: ['задача', 'сроки', 'бюджет', 'контакт для связи'],
    recommend_service: ['запрос', 'контекст', 'почему рекомендация уместна'],
};

export const AI_MANAGER_GOAL_DEFAULT_FLOW: Record<AIManagerGoal, string[]> = {
    qualify: ['Привязаться к запросу', 'Уточнить важные детали', 'Передать человеку, когда клиент готов'],
    recommend_service: ['Понять запрос', 'Нативно объяснить рекомендацию', 'Дать ссылку или следующий шаг'],
};

export function getAIManagerAvatarPalette(id?: AIManagerAvatarPaletteId | string) {
    if (id === 'telegram' || id === 'violet' || id === 'mint') {
        return AI_MANAGER_AVATAR_PALETTES[id];
    }

    return AI_MANAGER_AVATAR_PALETTES.aurora;
}
